module.exports = __webpack_public_path__ + "assets/img/404.9c42b8cb.jpg";